<template>
  <el-dialog
    id="popup_dialog"
    :title="titlu"
    :visible.sync="showPopup"
    class="my-dialog-class custom-width"
    :destroy-on-close="true"

  >
    <el-tooltip placement="bottom-end"  effect="light">
      <div slot="content">Se verifica emailul furnizat si se limiteaza la un anumit numar de programari pe zi.<br/>Daca nu se alege "Oricare centru de productie" atunci se limiteaza indiferent de serviciul programator. <br/> Limitarea se aplica doar pe programator, nu si la adaugarea programarii din service.</div>
      <i class="el-icon-info" style="font-size: 17px;color:#409EFF"></i>
    </el-tooltip>

    <div class="container">
      <el-form
        label-position="top"
        :inline="false"
        :rules="rules"
        label-width="100%"
        :model="selectedObject"
        ref="my-form"
        @submit.prevent="save"
        v-loading="loadingVisible"
      >
        <el-row :gutter="15">
          <el-col :md="6">
            <el-form-item label="Denumire" prop="Denumire">
              <el-input class="full-width" v-model="selectedObject.Denumire" />
            </el-form-item>
          </el-col>          
          <el-col :md="6">
            <el-form-item label="Email" prop="Email">
              <el-input class="full-width" v-model="selectedObject.Email" />
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="Limita pe zi" prop="LimitaZi">
              <el-input-number v-model="selectedObject.LimitaZi" :precision="0" :max="999999" :min="0"/>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label='Centru productie' prop="IdCentruProductie">
              <el-select v-model='selectedObject.IdCentruProductie' class='full-width' filterable >
                <el-option label="Oricare" value="-1" />
                <el-option v-for='item in Info.centre_productie' :key="'centre_productie' + item.Id" :label='item.Nume' :value='item.Id' />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopup = false"> Renunta </el-button>
        <el-button type="primary" @click="save"> Salveaza </el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "",
  extends: BasePage,
  data() {
    return {
      baseUrl: "",
      showPopup: false,
      titlu: "",
      mode: "add",
      selectedObject: {
        Denumire: "",
        Email: "",
        IdCentruProductie: "-1",
        LimitaZi: "",
      },
      Info: {},
      rules: {
        Denumire:               [{ required: true, message: "Campul este obligatoriu" }],
        Email:                  [{ required: true, message: "Campul este obligatoriu" }],
        IdCentruProductie:      [{ required: true, message: "Campul este obligatoriu" }],
        LimitaZi:               [{ required: true, message: "Campul este obligatoriu" }],
      },
    };
  },
  methods: {
    show_me: async function (id) {
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.titlu = "Adauga o limitare";
        this.selectedObject = { Denumire: "",
        Email: "",
        IdCentruProductie: "-1",
        LimitaZi: "", };
      } else {
        this.mode = "edit";
        this.titlu = "Editeaza o limitare";
        var result = await this.post("rezervari_limitare/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
      }
    },



    async get_info() {
      var response = await this.post("rezervari_limitare/get_info_for_dialog");
      this.Info.centre_productie = response.centre_productie;
    },
    async resetObject(){
      // this.selectedObject = { Nume: "" };
    },
    save: async function () {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          await this.post("rezervari_limitare/save", {
            mode: this.mode,
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.$emit("save");
          this.selectedObject = { Denumire: "",
                    Email: "",
                    IdCentruProductie: "",
                    LimitaZi: "", };
        }
      });
    },
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less">
#popup_dialog {
  .full-width {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .container {
    width: 100% !important;
  }

  @media only screen and (max-width: 600px) {
    .el-dialog{
      min-width: 90vw !important;
    }
  }
}
</style>